import i18n from '@/i18n';

export default [
  {
    path: '/sponsorships',
    name: 'logo-sponsorships',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'sponsorship',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('sponsorships')
    },
    // route level code-splitting
    component: () => import('../../views/sponsorships/Index'),
    children: [
      {
        path: 'new',
        name: 'logo-sponsorship-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'sponsorship',
              actions: ['store'],
            },
          ],
          title: i18n.global.t('new_sponsorship')
        },
        component: () => import('../../views/sponsorships/AddNew.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'logo-sponsorship-details',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'sponsorship',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('sponsorship_details')
        },
        component: () => import('../../views/sponsorships/Edit.vue'),
      },
    ]
  },
];
